import React, { useEffect } from 'react'

import { datadogRum } from '@datadog/browser-rum'
import { FeatureFlagList } from '@frame/lib/api/common/types'
import { useAutoNavigate } from '@frame/lib/hooks/useAutoNavigate'
import { useFeatureEnabled } from '@frame/lib/hooks/useFeatures'
import { useStore } from '@frame/lib/stores/useStore'
import { isVerifiedTask } from '@frame/lib/utils/tasks'

import { SearchEmployer } from './unified-search/search-employer'

export function CompanySearch() {
  const { autoNavigate } = useAutoNavigate()
  const { tasks, maxEmployments } = useStore(({ session }) => ({
    tasks: session?.tasks ?? [],
    maxEmployments: session?.max_employments ?? 1,
  }))

  const isUnifiedSearchEnabled = useFeatureEnabled(FeatureFlagList.UnifiedSearch)

  useEffect(() => {
    datadogRum.addFeatureFlagEvaluation(FeatureFlagList.UnifiedSearch, isUnifiedSearchEnabled)
  }, [isUnifiedSearchEnabled])

  const verifiedTasks = tasks.filter(isVerifiedTask)

  useEffect(() => {
    if (verifiedTasks.length >= maxEmployments) {
      autoNavigate()
    }
  }, [verifiedTasks, maxEmployments, autoNavigate])

  return <SearchEmployer />
}
